<div>
  <div class="giphy">
    <mat-form-field class="search">
      <input type="text" matInput (keyup)="searchTerm($event)" [(ngModel)]="search" placeholder="Search GIFs" #postboxInput>
    </mat-form-field>
    <div class="searchResults" *ngIf="results.length" (scroll)="resultsScroll($event)">
      <div class="result" *ngFor="let result of results" (click)="selectGIF(result.actual)" [ngStyle]="{'background-image':'url(\''+result.display+'\')'}"></div>
    </div>
    
    <i id="remove-gif" *ngIf="selected != null" (click)="searchTerm($event)" class="zmdi zmdi-close" title="remove"></i>
    <img [src]="selected" class="selected" *ngIf="selected != null">
    <div style="text-align:right;">
      <img [src]="defaultURL+'/images/giphy.png'" class="giphyLogo">
    </div>
  </div>
</div>